import type { FuelPriceHistory } from "../../hooks/react-query/backOffice/useFuelPriceHistory";

export const mockFuelPriceApiResponse = {
  success: true,
  message: "Fuel price data retrieved successfully",
  errorCode: null,
  item: {
    fuelPrices: [
      {
        id: 11,
        displayName: "California",
        effectiveDate: "02/23/2026",
        price: "4.944",
        createdOn: "02/20/2026",
        modifiedOn: "02/24/2026",
        isRetry: false,
        changePrice: "0.08",
        changePercentage: "1.73",
      },
      {
        id: 10,
        displayName: "PADD5 Except California",
        effectiveDate: "02/23/2026",
        price: "4.050",
        createdOn: "02/20/2026",
        modifiedOn: "02/24/2026",
        isRetry: false,
        changePrice: "0.08",
        changePercentage: "2.02",
      },
      {
        id: 9,
        displayName: "PADD5",
        effectiveDate: "02/23/2026",
        price: "4.465",
        createdOn: "02/20/2026",
        modifiedOn: "02/24/2026",
        isRetry: false,
        changePrice: "0.08",
        changePercentage: "1.87",
      },
      {
        id: 8,
        displayName: "PADD4",
        effectiveDate: "02/23/2026",
        price: "3.683",
        createdOn: "02/20/2026",
        modifiedOn: "02/24/2026",
        isRetry: true,
        changePrice: "0.08",
        changePercentage: "2.11",
      },
      {
        id: 7,
        displayName: "PADD3",
        effectiveDate: "02/23/2026",
        price: "3.489",
        createdOn: "02/20/2026",
        modifiedOn: "02/24/2026",
        isRetry: false,
        changePrice: "0.08",
        changePercentage: "2.26",
      },
      {
        id: 6,
        displayName: "PADD2",
        effectiveDate: "02/23/2026",
        price: "3.798",
        createdOn: "02/20/2026",
        modifiedOn: "02/24/2026",
        isRetry: false,
        changePrice: "0.13",
        changePercentage: "3.66",
      },
      {
        id: 5,
        displayName: "PADD1C",
        effectiveDate: "02/23/2026",
        price: "3.708",
        createdOn: "02/20/2026",
        modifiedOn: "02/24/2026",
        isRetry: false,
        changePrice: "0.10",
        changePercentage: "2.66",
      },
      {
        id: 4,
        displayName: "PADD1B",
        effectiveDate: "02/23/2026",
        price: "4.104",
        createdOn: "02/20/2026",
        modifiedOn: "02/24/2026",
        isRetry: false,
        changePrice: "0.07",
        changePercentage: "1.84",
      },
      {
        id: 3,
        displayName: "PADD1A",
        effectiveDate: "02/23/2026",
        price: "4.201",
        createdOn: "02/20/2026",
        modifiedOn: "02/24/2026",
        isRetry: false,
        changePrice: "-0.01",
        changePercentage: "-0.33",
      },
      {
        id: 2,
        displayName: "PADD1",
        effectiveDate: "02/23/2026",
        price: "3.843",
        createdOn: "02/20/2026",
        modifiedOn: "02/24/2026",
        isRetry: false,
        changePrice: "0.08",
        changePercentage: "2.13",
      },
      {
        id: 1,
        displayName: "National",
        effectiveDate: "02/23/2026",
        price: "3.809",
        createdOn: "02/20/2026",
        modifiedOn: "02/24/2026",
        isRetry: false,
        changePrice: "0.10",
        changePercentage: "2.64",
      },
    ],
  },
};

// Mock data for fuel price history
export const mockFuelPriceHistoryData: Record<number, FuelPriceHistory> = {
  1: {
    govtPriceCode: "National",
    priceValue: "$3.809",
    effectiveDate: "02/23/2026",
    createdOn: "02/20/2026",
    lastUpdated: "02/24/2026",
    history: [
      {
        price: "$3.809",
        modificationDate: "02/24/2026",
        modifiedBy: "John Smith",
      },
      {
        price: "$3.759",
        modificationDate: "02/17/2026",
        modifiedBy: "Sarah Johnson",
      },
      {
        price: "$3.709",
        modificationDate: "02/10/2026",
        modifiedBy: "Michael Brown",
      },
      {
        price: "$3.689",
        modificationDate: "02/03/2026",
        modifiedBy: "Emily Davis",
      },
      {
        price: "$3.729",
        modificationDate: "01/27/2026",
        modifiedBy: "David Wilson",
      },
      {
        price: "$3.799",
        modificationDate: "01/20/2026",
        modifiedBy: "Lisa Anderson",
      },
      {
        price: "$3.849",
        modificationDate: "01/13/2026",
        modifiedBy: "Robert Martinez",
      },
      {
        price: "$3.889",
        modificationDate: "01/06/2026",
        modifiedBy: "Jennifer Taylor",
      },
    ],
  },
  2: {
    govtPriceCode: "PADD1",
    priceValue: "$3.843",
    effectiveDate: "02/23/2026",
    createdOn: "02/20/2026",
    lastUpdated: "02/24/2026",
    history: [
      {
        price: "$3.843",
        modificationDate: "02/24/2026",
        modifiedBy: "Mark Johnson",
      },
      {
        price: "$3.793",
        modificationDate: "02/17/2026",
        modifiedBy: "Amanda Lee",
      },
      {
        price: "$3.763",
        modificationDate: "02/10/2026",
        modifiedBy: "Christopher White",
      },
      {
        price: "$3.713",
        modificationDate: "02/03/2026",
        modifiedBy: "Nicole Harris",
      },
      {
        price: "$3.753",
        modificationDate: "01/27/2026",
        modifiedBy: "Daniel Clark",
      },
    ],
  },
  3: {
    govtPriceCode: "PADD1A",
    priceValue: "$4.201",
    effectiveDate: "02/23/2026",
    createdOn: "02/20/2026",
    lastUpdated: "02/24/2026",
    history: [
      {
        price: "$4.201",
        modificationDate: "02/24/2026",
        modifiedBy: "Patricia Moore",
      },
      {
        price: "$4.211",
        modificationDate: "02/17/2026",
        modifiedBy: "Kevin Thompson",
      },
      {
        price: "$4.181",
        modificationDate: "02/10/2026",
        modifiedBy: "Rachel Garcia",
      },
      {
        price: "$4.151",
        modificationDate: "02/03/2026",
        modifiedBy: "Brian Martinez",
      },
      {
        price: "$4.191",
        modificationDate: "01/27/2026",
        modifiedBy: "Angela Robinson",
      },
      {
        price: "$4.231",
        modificationDate: "01/20/2026",
        modifiedBy: "Steven Walker",
      },
      {
        price: "$4.231",
        modificationDate: "01/20/2026",
        modifiedBy: "Steven",
      },
      {
        price: "$4.201",
        modificationDate: "02/24/2026",
        modifiedBy: "Patricia Moore",
      },
      {
        price: "$4.211",
        modificationDate: "02/17/2026",
        modifiedBy: "Kevin Thompson",
      },
      {
        price: "$4.181",
        modificationDate: "02/10/2026",
        modifiedBy: "Rachel Garcia",
      },
      {
        price: "$4.151",
        modificationDate: "02/03/2026",
        modifiedBy: "Brian Martinez",
      },
      {
        price: "$4.191",
        modificationDate: "01/27/2026",
        modifiedBy: "Angela Robinson",
      },
      {
        price: "$4.231",
        modificationDate: "01/20/2026",
        modifiedBy: "Steven Walker",
      },
      {
        price: "$4.231",
        modificationDate: "01/20/2026",
        modifiedBy: "Steven",
      },
    ],
  },
  4: {
    govtPriceCode: "PADD1B",
    priceValue: "$4.104",
    effectiveDate: "02/23/2026",
    createdOn: "02/20/2026",
    lastUpdated: "02/24/2026",
    history: [
      {
        price: "$4.104",
        modificationDate: "02/24/2026",
        modifiedBy: "Michelle Hall",
      },
      {
        price: "$4.034",
        modificationDate: "02/17/2026",
        modifiedBy: "Jason Allen",
      },
      {
        price: "$3.994",
        modificationDate: "02/10/2026",
        modifiedBy: "Stephanie Young",
      },
      {
        price: "$3.964",
        modificationDate: "02/03/2026",
        modifiedBy: "Timothy King",
      },
    ],
  },
  5: {
    govtPriceCode: "PADD1C",
    priceValue: "$3.708",
    effectiveDate: "02/23/2026",
    createdOn: "02/20/2026",
    lastUpdated: "02/24/2026",
    history: [
      {
        price: "$3.708",
        modificationDate: "02/24/2026",
        modifiedBy: "Rebecca Wright",
      },
      {
        price: "$3.608",
        modificationDate: "02/17/2026",
        modifiedBy: "Gregory Lopez",
      },
      {
        price: "$3.558",
        modificationDate: "02/10/2026",
        modifiedBy: "Melissa Hill",
      },
      {
        price: "$3.528",
        modificationDate: "02/03/2026",
        modifiedBy: "Jeffrey Scott",
      },
      {
        price: "$3.568",
        modificationDate: "01/27/2026",
        modifiedBy: "Laura Green",
      },
    ],
  },
  6: {
    govtPriceCode: "PADD2",
    priceValue: "$3.798",
    effectiveDate: "02/23/2026",
    createdOn: "02/20/2026",
    lastUpdated: "02/24/2026",
    history: [
      {
        price: "$3.798",
        modificationDate: "02/24/2026",
        modifiedBy: "Andrew Adams",
      },
      {
        price: "$3.668",
        modificationDate: "02/17/2026",
        modifiedBy: "Cynthia Baker",
      },
      {
        price: "$3.618",
        modificationDate: "02/10/2026",
        modifiedBy: "Ryan Nelson",
      },
      {
        price: "$3.598",
        modificationDate: "02/03/2026",
        modifiedBy: "Ashley Carter",
      },
      {
        price: "$3.638",
        modificationDate: "01/27/2026",
        modifiedBy: "Brandon Mitchell",
      },
      {
        price: "$3.688",
        modificationDate: "01/20/2026",
        modifiedBy: "Heather Perez",
      },
    ],
  },
  7: {
    govtPriceCode: "PADD3",
    priceValue: "$3.489",
    effectiveDate: "02/23/2026",
    createdOn: "02/20/2026",
    lastUpdated: "02/24/2026",
    history: [
      {
        price: "$3.489",
        modificationDate: "02/24/2026",
        modifiedBy: "Matthew Roberts",
      },
      {
        price: "$3.409",
        modificationDate: "02/17/2026",
        modifiedBy: "Kimberly Turner",
      },
      {
        price: "$3.369",
        modificationDate: "02/10/2026",
        modifiedBy: "Joshua Phillips",
      },
      {
        price: "$3.339",
        modificationDate: "02/03/2026",
        modifiedBy: "Amy Campbell",
      },
    ],
  },
  8: {
    govtPriceCode: "PADD4",
    priceValue: "$3.683",
    effectiveDate: "02/23/2026",
    createdOn: "02/20/2026",
    lastUpdated: "02/24/2026",
    history: [
      {
        price: "$3.683",
        modificationDate: "02/24/2026",
        modifiedBy: "Eric Parker",
      },
      {
        price: "$3.603",
        modificationDate: "02/17/2026",
        modifiedBy: "Samantha Evans",
      },
      {
        price: "$3.563",
        modificationDate: "02/10/2026",
        modifiedBy: "Jacob Edwards",
      },
      {
        price: "$3.533",
        modificationDate: "02/03/2026",
        modifiedBy: "Christina Collins",
      },
      {
        price: "$3.573",
        modificationDate: "01/27/2026",
        modifiedBy: "Nicholas Stewart",
      },
    ],
  },
  9: {
    govtPriceCode: "PADD5",
    priceValue: "$4.465",
    effectiveDate: "02/23/2026",
    createdOn: "02/20/2026",
    lastUpdated: "02/24/2026",
    history: [
      {
        price: "$4.465",
        modificationDate: "02/24/2026",
        modifiedBy: "Tyler Sanchez",
      },
      {
        price: "$4.385",
        modificationDate: "02/17/2026",
        modifiedBy: "Megan Morris",
      },
      {
        price: "$4.345",
        modificationDate: "02/10/2026",
        modifiedBy: "Aaron Rogers",
      },
      {
        price: "$4.315",
        modificationDate: "02/03/2026",
        modifiedBy: "Lauren Reed",
      },
      {
        price: "$4.355",
        modificationDate: "01/27/2026",
        modifiedBy: "Jordan Cook",
      },
      {
        price: "$4.405",
        modificationDate: "01/20/2026",
        modifiedBy: "Alexis Morgan",
      },
    ],
  },
  10: {
    govtPriceCode: "PADD5 Except California",
    priceValue: "$4.050",
    effectiveDate: "02/23/2026",
    createdOn: "02/20/2026",
    lastUpdated: "02/24/2026",
    history: [
      {
        price: "$4.050",
        modificationDate: "02/24/2026",
        modifiedBy: "Nathan Bell",
      },
      {
        price: "$3.970",
        modificationDate: "02/17/2026",
        modifiedBy: "Victoria Murphy",
      },
      {
        price: "$3.930",
        modificationDate: "02/10/2026",
        modifiedBy: "Justin Bailey",
      },
      {
        price: "$3.900",
        modificationDate: "02/03/2026",
        modifiedBy: "Brittany Rivera",
      },
    ],
  },
  11: {
    govtPriceCode: "California",
    priceValue: "$4.944",
    effectiveDate: "02/23/2026",
    createdOn: "02/20/2026",
    lastUpdated: "02/24/2026",
    history: [
      {
        price: "$4.944",
        modificationDate: "02/24/2026",
        modifiedBy: "Austin Cooper",
      },
      {
        price: "$4.864",
        modificationDate: "02/17/2026",
        modifiedBy: "Hannah Richardson",
      },
      {
        price: "$4.824",
        modificationDate: "02/10/2026",
        modifiedBy: "Zachary Cox",
      },
      {
        price: "$4.794",
        modificationDate: "02/03/2026",
        modifiedBy: "Katherine Howard",
      },
      {
        price: "$4.834",
        modificationDate: "01/27/2026",
        modifiedBy: "Kyle Ward",
      },
      {
        price: "$4.884",
        modificationDate: "01/20/2026",
        modifiedBy: "Olivia Torres",
      },
      {
        price: "$4.924",
        modificationDate: "01/13/2026",
        modifiedBy: "Sean Peterson",
      },
    ],
  },
};
